import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import * as _ from 'lodash';

import { Campaign, PlaylistContent } from '../models/campaign';
import { HttpService } from '../../../../../services/http.service';
import { Constants } from '../../../../../app.constant';

@Injectable()

export class CampaignService extends HttpService {

  public response: any;
  public campaignObj: any;

  // This function is used to set data in serviceObj
  setCampaignObj = function (res: any = {}) {
    this.campaignObj = res;
  };

  // This function is used to return serviceObj data.
  getCampaignObj = function () {
    return this.campaignObj;
  };

  getCampaigns(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/layout/', requestOptionsArgs, 'campaign-list', false)
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getArchivedCampaigns(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/layout/archive', requestOptionsArgs, 'campaign-archive')
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getPendingCampaigns(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/layout/waiting-for-approval/', requestOptionsArgs, 'campaign-list')
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignById(layoutId: any): Observable<Campaign> {
    let requestOptionsArgs = {};
    return this.getApi('/layout/' + layoutId, requestOptionsArgs, 'campaign-one-128', false)
      .map(res => {
        return res.json() && res.json().result && <Campaign>res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  deleteCampaign(params: any): Observable<any> {
    let requestOptionsArgs = new RequestOptions({ body: { 'ids': params } });
    return this.deleteApi('/layout', requestOptionsArgs, 'remove-campaign')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  cloneCampaign(campaignId): Observable<Campaign> {
    //campaign = _.assignIn({}, campaign);

    let requestOptionsArgs = {};
    return this.postApi('/layout/clone/' + campaignId, requestOptionsArgs, 'clone-campaign')
      .map(res => {
        return res.json() && res.json().result && <Campaign>res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getAspectRatioList(): Observable<any> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/aspectRatio', requestOptionsArgs, 'aspect-ratio-list')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignsByAdvanceSearch(param): Observable<any> {
    const optionals = Constants.setParamsObject(param);
    let searchQuery: any;
    let query = optionals.split('=')
    if (query[1] != '%7B%7D') {
      searchQuery = optionals;
    } else {
      searchQuery = '';
    }
    let requestOptionsArgs = {};
    return this.getApi('/layout' + searchQuery, requestOptionsArgs, 'campaign-list')
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignFullDetails(layoutId, mediaService): Observable<Campaign> {
    return this.getCampaignById(layoutId)
      .flatMap((_campaign: Campaign) => {    // Get 'audios' contents & backgroundImage then merge into campaign
        let letForkArr = [Observable.of(_campaign)];
        letForkArr.push(
          _campaign.backgroundImageContentId
            ? mediaService.getMediaById(_campaign.backgroundImageContentId)    // Fetch backgroundImage if exist in 1st position in array.
            : Observable.of({})
        );
        if (!_.isEmpty(_.get(_campaign, 'audios', []))) {
          _.forEach(_campaign['audios'], audio => {
            if (audio && audio.contentId) {
              letForkArr.push(
                mediaService.getMediaById(audio.contentId)
                  .map(res => res)
                  .catch((res: Response) => { return Observable.of({}) })
              );
            }
          })
        }
        return Observable.forkJoin(letForkArr)
          .map((dataList: any[]) => {
            let _campaign: Campaign = dataList[0];
            let backgroundImage: PlaylistContent = dataList[1];
            dataList.splice(0, 2);
            if (!_.isEmpty(backgroundImage)) {
              _campaign.backgroundImageContent = backgroundImage;
              _campaign.backgroundImageUrl = backgroundImage.mediaUrl;
            }
            if (_.isEmpty(_campaign.audios)) {
              _campaign.audios = <PlaylistContent[]>[];
            }
            _.merge(_campaign.audios, dataList);
            _campaign.audios.sort(function (a, b) { return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0); });
            return _campaign;
          })
      })

      .flatMap((_campaign: Campaign) => {    // Get 'region.globalRegionContentPlaylistContents' contents and merge into campaign

        let letForkArr = [Observable.of(_campaign)];

        // get details of all contents of regions
        _.map(_campaign.regions, (region) => _.map(region.globalRegionContentPlaylistContents, (content: PlaylistContent) => {
          if (content && content.contentId) {
            letForkArr.push(
              mediaService.getMediaById(content.contentId).map(res => res).catch((res: Response) => { return Observable.of({}) })
            );
          } else if (content && content.widgetType) {
            letForkArr.push(
              mediaService.getWidgetByType(content.widgetType).map(res => res).catch((res: Response) => { return Observable.of({}) })
            );
          }
          return content;
        }))
        return Observable.forkJoin(letForkArr)
          .map((dataList: any[]) => {
            let _camp: Campaign = dataList[0];
            dataList.splice(0, 1);

            // assign content details with respect to content
            _.map(_camp.regions, (region) => {
              region.totalDurationInSeconds = 0;  // initalize to zero, then add content duration in map function.
              _.map(region.globalRegionContentPlaylistContents, (content) => {

                // Add contentDuration to totalDurationInSeconds
                region.totalDurationInSeconds += content.durationInSeconds;

                // Find related full-content and merge into existing one
                let contentDetail = _.find(dataList, { contentId: content.contentId });
                if (!_.isEmpty(contentDetail)) {
                  if (content.displayMode != null) delete contentDetail.displayMode
                  _.assignIn(content, contentDetail);
                }
                return content;
              })
              // console.log('before sort global', region.globalRegionContentPlaylistContents);
              region.globalRegionContentPlaylistContents.sort(function (a, b) { return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0); });
              // console.log('after sort global', region.globalRegionContentPlaylistContents);

              return region;
            })
            return _camp;
          });
      });
  }

  getTags(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/layoutTags', requestOptionsArgs, 'tag-list', false)
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  addAdvertismemtLayout(dataParams) {
    let requestOptionsArgs = { body: dataParams };
    return this.postApi('/layout-advertisement', requestOptionsArgs, 'device')
      .map(data => {
        return data.json();
      }).catch((e) => Observable.throw(this.errorHandler(e)));
  }

  updateAdvertisementLayout(dataParams, layoutId) {
    let requestOptionsArgs = { body: dataParams };
    return this.putApi('/layout-advertisement/' + layoutId, requestOptionsArgs, 'device')
      .map(data => {
        return data.json();
      }).catch((e) => Observable.throw(this.errorHandler(e)));
  }

  archiveCampaign(campaignId, type): Observable<Campaign> {
    //campaign = _.assignIn({}, campaign);

    let requestOptionsArgs = {body: campaignId};
    let url = type == 'archive' ? '/layout/archive' : '/layout/unarchive';
    return this.postApi(url, requestOptionsArgs, 'campaign-archive')
      .map(res => {
        return res.json() && res.json().result && <Campaign>res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }




}


// WEBPACK FOOTER //
// ./src/app/pages/cms/components/campaign/services/campaign.service.ts